import { render, staticRenderFns } from "./estoquerastreio.vue?vue&type=template&id=0817c4aa&"
import script from "./estoquerastreio.vue?vue&type=script&lang=js&"
export * from "./estoquerastreio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports